import { render, staticRenderFns } from "./Strabane.vue?vue&type=template&id=d26cc974&scoped=true"
import script from "./Strabane.vue?vue&type=script&lang=js"
export * from "./Strabane.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/inbox.css?vue&type=style&index=0&id=d26cc974&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d26cc974",
  null
  
)

export default component.exports